import { useMediaQuery } from "@vueuse/core";

import { INPUT_DATE_REFLOW_MEDIA_QUERY } from "./constants";

export function useInputDateReflow() {
  return {
    isReflowed: useMediaQuery(INPUT_DATE_REFLOW_MEDIA_QUERY),
  };
}

export default useInputDateReflow;
